import React, { PureComponent } from "react";

import styles from "./Drawer.local.scss";
import classnames from "classnames";

export default class DrawerComponent extends PureComponent {
  render() {
    const {
      label,
      icon,
      src,
      openIframe,
      type,
      isActive,
      isSmall
    } = this.props;
    return (
      <div
        className={classnames(
          styles.drawer,
          isActive ? styles.active : "",
          type && type === "CLOSE" ? styles.close : "",
          isSmall ? styles.small : ""
        )}
        onClick={openIframe.bind(this, src)}
      >
        {icon}
        <span>{label}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Drawer/DrawerComponent.js